import React from 'react'
import { Helmet } from 'react-helmet'
import './confidentialitate.css'

const Confidentialitate = () => {
  return (
    <div className="confidentialitate-container">
      <Helmet>
        <title>Politica de Confidențialitate - Sustin.ro</title>
        <meta property="og:title" content="Politica de Confidențialitate - Sustin.ro" />
      </Helmet>

      <img
        alt="background"
        src="/external/map.svg"
        className="confidentialitate-map"
      />

      <div className="confidentialitate-content">
        <h1 className="confidentialitate-title">Politica de Confidențialitate</h1>
        
        <section className="confidentialitate-section">
    <h2>1. Scop și domeniu de aplicare</h2>
    <p>
      Această politică stabilește principiile prin care operatorul colectează, utilizează și protejează datele dumneavoastră în timpul navigării și utilizării Sustine.ro. Ne angajăm să respectăm confidențialitatea și drepturile persoanelor vizate.
    </p>
  </section>

  <section className="confidentialitate-section">
    <h2>2. Categorii de date prelucrate</h2>
    <ul>
      <li><p><strong>Date de identificare</strong>: cum ar fi nume, prenume și CNP, necesare pentru serviciile fiscale.</p></li>
      <li><p><strong>Date de contact</strong>: adresă poștală, email și număr de telefon, folosite pentru comunicări și notificări.</p></li>
      <li><p><strong>Date de navigare</strong>: cookie-uri, adrese IP și preferințe de utilizare, pentru optimizarea experienței pe site.</p></li>
      <li><p><strong>Date de participare</strong>: 
        <ul>
          <li><p>Informații despre participarea la tombola generală</p></li>
          <li><p>Link-uri de afiliere generate și utilizate</p></li>
          <li><p>Statistici privind numărul de formulare completate prin afiliere</p></li>
          <li><p>Statutul validării formularelor de către ANAF</p></li>
        </ul>
      </p></li>
    </ul>
  </section>

  <section className="confidentialitate-section">
    <h2>3. Baze legale ale prelucrării</h2>
    <ul>
      <li><p><strong>Consimțământ</strong>: în special pentru cookie-uri, newsletter sau sondaje.</p></li>
      <li><p><strong>Obligațiile legale</strong>: reținerea datelor conform legislației fiscale.</p></li>
      <li><p><strong>Interesul legitim</strong>: 
        <ul>
          <li><p>Îmbunătățirea serviciilor și asigurarea securității platformei</p></li>
          <li><p>Gestionarea corectă a tombolelor și a programului de afiliere</p></li>
          <li><p>Validarea eligibilității pentru premii și recompense</p></li>
        </ul>
      </p></li>
    </ul>
  </section>

  <section className="confidentialitate-section">
    <h2>4. Modalități de colectare</h2>
    <ul>
      <li><p><strong>Direct de la utilizator</strong>: prin completarea formularelor online.</p></li>
      <li><p><strong>Automat</strong>: prin cookie-uri și log-uri ale serverului, pentru analize statistice.</p></li>
    </ul>
  </section>

  <section className="confidentialitate-section">
    <h2>5. Scopurile prelucrării</h2>
    <ul>
      <li><p><strong>Furnizarea serviciilor</strong>: completarea și depunerea Formularului 230.</p></li>
      <li><p><strong>Gestionarea tombolelor</strong>: 
        <ul>
          <li><p>Înregistrarea participanților la tombola generală</p></li>
          <li><p>Validarea eligibilității pentru premii</p></li>
          <li><p>Distribuția premiilor conform regulilor stabilite</p></li>
        </ul>
      </p></li>
      <li><p><strong>Programul de afiliere</strong>: 
        <ul>
          <li><p>Urmărirea numărului de formulare completate prin link-uri de afiliere</p></li>
          <li><p>Validarea eligibilității pentru recompense</p></li>
          <li><p>Distribuția premiilor garantate și a celor din tombolă</p></li>
        </ul>
      </p></li>
      <li><p><strong>Îmbunătățirea experienței</strong>: personalizarea conținutului și optimizarea performanței site-ului.</p></li>
      <li><p><strong>Marketing</strong>: trimiterea newsletter-elor și ofertelor relevante, numai cu acordul explicit.</p></li>
      <li><p><strong>Obligații fiscale</strong>: raportări către ANAF și autorități.</p></li>
    </ul>
  </section>

  <section className="confidentialitate-section">
    <h2>6. Partajarea datelor</h2>
    <ul>
      <li><p><strong>Furnizori de servicii</strong>: companii tehnice și de hosting, cu care avem colaborări ce prevăd protecția datelor.</p></li>
      <li><p><strong>Autorități fiscale</strong>: ANAF primește datele necesare pentru redirecționarea impozitului.</p></li>
      <li><p><strong>Parteneri de cazare</strong>: ne rezervăm dreptul de a transmite datele personale ale utilizatorilor câștigători către unități de cazare partenere, exclusiv pentru onorarea premiilor.</p></li>
      <li><p><strong>Alte situații</strong>: doar la cererea autorităților competente sau cu consimțământul dumneavoastră.</p></li>
    </ul>
  </section>

  <section className="confidentialitate-section">
    <h2>7. Cookie-uri și tehnologii similare</h2>
    <ul>
      <li><p><strong>Cookie-uri esențiale</strong>: necesare funcționării site-ului.</p></li>
      <li><p><strong>Cookie-uri de performanță</strong>: pentru analiza traficului și îmbunătățirea vitezei.</p></li>
      <li><p><strong>Cookie-uri de marketing</strong>: pentru afișarea de reclame relevante, cu acordul explicit.</p></li>
    </ul>
    <p>Puteți gestiona și șterge cookie-urile din setările browserului.</p>
  </section>

  <section className="confidentialitate-section">
    <h2>8. Drepturile persoanelor vizate</h2>
    <p>
      Aveți dreptul de a accesa, rectifica, șterge sau restricționa prelucrarea datelor, dreptul la portabilitatea datelor și opoziție față de prelucrare. De asemenea, puteți retrage consimțământul în orice moment și puteți depune o plângere la ANSPDCP.
    </p>
  </section>

  <section className="confidentialitate-section">
    <h2>9. Securitatea și retenția datelor</h2>
    <p>
      Măsurile noastre includ criptare, backup-uri regulate și control strict al accesului. Datele sunt păstrate conform legii, de obicei pentru 5 ani de la sfârșitul anului fiscal relevant.
    </p>
  </section>

  <section className="confidentialitate-section">
    <h2>10. Contact și informații suplimentare</h2>
    <p>
      Pentru întrebări, solicitări de exercitare a drepturilor sau reclamații, ne puteți contacta la:<br />
      Email: <a href="mailto:hi@romania.org.ro">hi@romania.org.ro</a><br />
    </p>
  </section>

  <section className="confidentialitate-section">
    <h2>11. Modificări ale politicii</h2>
    <p>
      Putem actualiza această politică în funcție de modificările legislative sau ale serviciilor. Orice schimbare va fi anunțată prin publicarea pe site și actualizarea datei ultimei revizuiri.
    </p>
  </section>

        <div className="confidentialitate-footer">
          <p>
            Ultima actualizare: {new Date().toLocaleDateString('ro-RO')}
          </p>  
          <p>
          Pentru întrebări sau clarificări privind politica de confidențialitate, vă rugăm să ne contactați la:<br />
      Email: <a href="mailto:hi@romania.org.ro">hi@romania.org.ro</a><br />
          </p>        
        </div>
      </div>
    </div>
  )
}

export default Confidentialitate 